import { getEnv } from '@/lib/env'

/**
 * Landing page variant loader
 * Similar to medconnect-professional approach but for landing page variants
 */
export function getLandingVariant(): string {
    // Get the landing variant from environment variables
    // If not set or empty, defaults to 'default'
    const variant = getEnv('NEXT_PUBLIC_LANDING_VARIANT', 'default')

    // Validate the variant to ensure it's one of the supported options
    const supportedVariants = ['default', 'custom', 'customer1', 'customer2', 'zoomdocny', 'cubesante']

    if (supportedVariants.includes(variant)) {
        return variant
    }

    // If invalid variant, fall back to default
    console.warn(`Invalid landing variant "${variant}", falling back to "default"`)
    return 'default'
}

/**
 * Check if we should use custom branding
 */
export function shouldUseCustomBranding(): boolean {
    const variant = getLandingVariant()
    return variant !== 'default'
}
